/** Role names used for Overview analytics and list-scope controls. */
export const SCHOOL_BUILDING_ADMIN_ROLE_NAME = 'School-Building Administrator';
export const ESD_ADMINISTRATOR_ROLE_NAME = 'ESD Administrator';
export const DISTRICT_ADMINISTRATOR_ROLE_NAME = 'District Administrator';
export const SYSTEM_ADMINISTRATOR_ROLE_NAME = 'System Administrator';
const PRIVILEGED_ROLE_NAMES = new Set([
    'esd administrator',
    'district administrator',
    'system administrator',
]);
function normalizeRoleName(roleName) {
    return (roleName ?? '').trim().toLowerCase();
}
function normalizeRoleKey(roleName) {
    return normalizeRoleName(roleName).replace(/[-_/]+/g, ' ').replace(/\s+/g, ' ');
}
export function isOverviewPrivileged(roleName) {
    return PRIVILEGED_ROLE_NAMES.has(normalizeRoleName(roleName));
}
/** Matches a Processor role if Kokomo adds one; none of the current admin roles use this. */
export function isOverviewProcessor(roleName) {
    return normalizeRoleKey(roleName).includes('processor');
}
/** Building admins see and create L1s only at sites they are assigned. */
export function isSchoolBuildingAdministrator(roleName) {
    const key = normalizeRoleKey(roleName);
    if (!key)
        return false;
    if (key === normalizeRoleKey(SCHOOL_BUILDING_ADMIN_ROLE_NAME))
        return true;
    return key.includes('school') && key.includes('building') && key.includes('administrator');
}
export function isDistrictAdministrator(roleName) {
    const key = normalizeRoleKey(roleName);
    if (!key)
        return false;
    if (key === normalizeRoleKey(DISTRICT_ADMINISTRATOR_ROLE_NAME))
        return true;
    return key.includes('district') && key.includes('administrator');
}
/** School and district admins may open an L2 only after it is closed. */
export function locksOpenL2(roleName) {
    return isSchoolBuildingAdministrator(roleName) || isDistrictAdministrator(roleName);
}
/** ESD administrators get Safety Cloud review links in notifications. */
export function isEsdAdministrator(roleName) {
    const key = normalizeRoleKey(roleName);
    if (!key)
        return false;
    if (key === normalizeRoleKey(ESD_ADMINISTRATOR_ROLE_NAME))
        return true;
    return key.includes('esd') && key.includes('administrator');
}
